export const initTable = () => {
  document.querySelectorAll('.product-table .product-table__body .product-table__row--head').forEach(node => {
    node.addEventListener('click', (ev) => {
      const el = ev.target.closest('.product-table__body')
      if(el){
        const isOpen = el.classList.contains('expanded') 
        document.querySelectorAll('.product-table__body.expanded').forEach(body => body.classList.remove('expanded'))
        if(isOpen) el.classList.remove('expanded')
        else el.classList.add('expanded')
      }
    })
  })
}